import { Injectable } from '@angular/core';
import { Order, QueryConfig, QueryEntity } from '@datorama/akita';
import { BadgesV2State, BadgesV2Store } from './badgesv2.store';
import { BadgeStatus } from './badge-status.enum';
import { map, Observable } from 'rxjs';
import { Badges } from './badges.model';
import { BadgesByCategory } from './badges-by-category.model';
import { Sort } from '../../../shared/sort.util';

@Injectable({ providedIn: 'root' })
@QueryConfig({ sortBy: 'Ordinal', sortByOrder: Order.ASC })
export class BadgesV2Query extends QueryEntity<BadgesV2State> {
  constructor(protected store: BadgesV2Store) {
    super(store);
  }

  selectAllBadgesByCategory(): Observable<BadgesByCategory[]> {
    return this.selectAll().pipe(
      map((badgesCategories) =>
        badgesCategories.map((badgesCategory) => ({
          ...badgesCategory,
          Badges: [
            ...badgesCategory.Badges.filter(this._filterByStatus(BadgeStatus.Completed)),
            ...badgesCategory.Badges.filter(this._filterByStatus(BadgeStatus.NotCompleted)),
          ],
        }))
      )
    );
  }

  selectCompleted() {
    return this.selectAll().pipe(
      map((badgesCategories) =>
        badgesCategories.map(
          (badgesCategory) =>
            ({
              ...badgesCategory,
              Badges: badgesCategory.Badges.filter(this._filterByStatus(BadgeStatus.Completed)),
            }) as BadgesByCategory
        )
      )
    );
  }

  getAllBadgeAchieved(badgeSize: number = 5) {
    return this.selectAll().pipe(
      map((badgesCategories) => {
        const allBadge = badgesCategories.reduce((pre, cur) => pre.concat(cur.Badges), [] as Badges[]);
        const completedBage = [...allBadge]
          .filter(this._filterByStatus(BadgeStatus.Completed))
          .sort(Sort.by('CompletionDate', 'asc', { type: 'date' }));
        const incompletedBage = [...allBadge]
          .filter(this._filterByStatus(BadgeStatus.NotCompleted))
          .sort(Sort.by('StartDate', 'asc', { type: 'date' }));
        const badgeAchieved = completedBage.concat(incompletedBage);
        badgeAchieved.length > badgeSize && (badgeAchieved.length = badgeSize);
        return badgeAchieved;
      })
    );
  }

  getNumberOfCompletedBadge() {
    return this.selectCompleted().pipe(
      map((badgesCategories) => badgesCategories.reduce((pre, cur) => pre.concat(cur.Badges), [] as Badges[]).length)
    );
  }

  private _filterByStatus(status: BadgeStatus) {
    return (badge: Badges) => badge.Status === status;
  }
}
